module.exports = __webpack_public_path__ + "assets/img/aiwriter-banner.e92845b0.png";